/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('ui.tinymce', [])
  .value('uiTinymceConfig', {})
  .directive('uiTinymce', ['uiTinymceConfig', function (uiTinymceConfig) {
      uiTinymceConfig = uiTinymceConfig || {};
      var generatedIds = 0;
      return {
          priority: 10,
          require: 'ngModel',
          link: function (scope, elm, attrs, ngModel) {
              var expression, options, tinyInstance,
                updateView = function () {                    
                    ngModel.$setViewValue(elm.val());
                    if (!scope.$root.$$phase) {
                        scope.$apply();
                    }
                };
              if (!attrs.id) {
                  attrs.$set('id', 'uiTinymce' + generatedIds++);
              }

              if (attrs.uiTinymce) {
                  expression = scope.$eval(attrs.uiTinymce);
              } else {
                  expression = {};
              }
              options = {
                  setup: function (ed) {
                      ed.on('init', function (args) {
                          ngModel.$render();
                      });
                      ed.on('ExecCommand', function (e) {
                          ed.save();
                          updateView();
                      });
                      ed.on('KeyUp', function (e) {
                          ed.save();
                          updateView();
                      });
                      ed.on('SetContent', function (e) {
                          if (!e.initial) {
                              ed.save();
                              updateView();
                          }
                      });                      

                      if (expression.setup) {
                          scope.$eval(expression.setup);
                          delete expression.setup;
                      }
                  },
                  mode: 'exact',
                  elements: attrs.id,
                  invalid_elements: 'script,style',
                  paste_strip_class_attributes : 'all',
                  paste_preprocess: function (pl, o) {
                     
                      var walk_the_DOM = function walk(node, func) {
                          func(node);
                          node = node.firstChild;
                          while (node) {
                              walk(node, func);
                              node = node.nextSibling;
                          }
                      };
                      var wrapper = document.createElement('div');
                      wrapper.innerHTML = o.content;
                      walk_the_DOM(wrapper.firstChild, function (element) {
                          if (element.removeAttribute) {
                              element.removeAttribute('id');
                              element.removeAttribute('style');
                              element.removeAttribute('class');
                          }
                      });

                      o.content = wrapper.innerHTML;
                  },
              };
              // extend options with initial uiTinymceConfig and options from directive attribute value
              angular.extend(options, uiTinymceConfig, expression);
              setTimeout(function () {
                  tinymce.init(options);
              });


              ngModel.$render = function () {
                  if (!tinyInstance) {
                      tinyInstance = tinymce.get(attrs.id);
                  }
                  if (tinyInstance) {
                      tinyInstance.setContent(ngModel.$viewValue || '');
                  }
              };
          }
      };
  }]);
